import React from 'react';
import TodoPokemonGamesList from '../Components/TodoPokemonGamesList';

const TodoPokemonGames = () => {
  return (
    <div>
      <TodoPokemonGamesList />
    </div>
  );
};

export default TodoPokemonGames;
